import * as _ from "lodash";
import { Components } from "formiojs";
import { ValidationPatterns } from "@bbwt/modules/validation";

const TextFieldComponent = Components.components.textfield;

export default class MiproPatientPhoneField  extends TextFieldComponent  {

    static schema() {
        return TextFieldComponent.schema({
            type: "miproPatientPhoneField",
            label: "Patient Phone",
            key: "dbo.mipro.miproPatientPhone",
            placeholder: "Enter Patient Phone", 
            disabled: false, 
            input: true,
            validate: {
                custom: `valid = (!input || !!input.match(/${ValidationPatterns.phone}/)) ? true : "Invalid phone number";`
            }
        });
    }

    init() {
        super.init();
    }

    static get builderInfo() {
        return {
            title: "Patient Phone Number",
            group: "basic",
            icon: "phone",
            weight: 70,
            schema: MiproPatientPhoneField.schema(),            
        };
    }
}

Components.addComponent("miproPatientPhoneField", MiproPatientPhoneField);